import React from 'react';
import { PropTypes } from 'prop-types';
import { map } from 'lodash';
import { Col, Container, Row } from 'reactstrap';
import { PayerRadioButton2 } from './PayerRadioButton2';

const RadioButtonGroup = ({ title, items, selectedItem, setSelectedItem, disabled = false, inline = false }) => {
  return (
    <Container className="p-0 m-0">
      <Row>
        <Col>{title}</Col>
      </Row>
      <Row>
        {map(items, (item, id) => (
          <Col key={id} xs={inline ? 'auto' : '12'}>
            <PayerRadioButton2
              title={item}
              selected={selectedItem === id}
              setSelected={selected => selected && setSelectedItem && setSelectedItem(id)}
              disabled={disabled}
            />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

RadioButtonGroup.propTypes = {
  title: PropTypes.node.isRequired,
  items: PropTypes.object.isRequired,
  selectedItem: PropTypes.string,
  setSelectedItem: PropTypes.func,
  disabled: PropTypes.bool,
  inline: PropTypes.bool,
};

export { RadioButtonGroup };
